import * as React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface FormErrorProps {
  message?: string | null;
  className?: string;
  variant?: "default" | "destructive";
}

/**
 * Form Error Component
 *
 * Displays form-level error messages in a styled alert.
 */
export function FormError({
  message,
  className,
  variant = "destructive",
}: FormErrorProps) {
  if (!message) return null;

  return (
    <Alert
      variant={variant}
      className={cn(
        "animate-in fade-in-0 slide-in-from-top-1 duration-200",
        className
      )}
    >
      {variant === "destructive" ? (
        <XCircle className="h-4 w-4" />
      ) : (
        <AlertCircle className="h-4 w-4" />
      )}
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}

export default FormError;
